// Quiz Data
const quizData = {
  questions: [
    {
      id: 1,
      text: "Is your organisation a UK registered charity?",
      type: "yesno",
      correct_answer: "Yes",
      fail_explanation: [
        `<p>We're sorry you're not eligible for a grant.</p>
                <p>Thank you for your interest in applying to the Charles Hayward Foundation but you do not meet our minimum criteria for funding.</p>
                <p>We are sorry for any disappointment and wish you well in securing funds from other sources.</p>`,
      ],
    },

    {
      id: 2,
      text: "Has your charity filed at least one set of annual accounts?",
      type: "yesno",
      correct_answer: "Yes",
      fail_explanation: [
        `<p>We're sorry you're not eligible for a grant.</p>
                <p>Thank you for your interest in applying to the Charles Hayward Foundation but you do not meet our minimum criteria for funding.</p>
                <p>We are sorry for any disappointment and wish you well in securing funds from other sources.</p>`,
      ],
    },
    {
      id: 3,
      text: "Please select your project category",
      type: "category",
      options: {
        A: {
          name: "Social & Criminal Justice",
          sub_questions: [
            {
              text: "Is your charity's annual income between £350,000 and £4million?",
              type: "yesno",
              correct_answer: "Yes",
              fail_explanation: [
                `<p>We're sorry you're not eligible for a grant.</p>
                                <p>Thank you for your interest in applying to the Charles Hayward Foundation but you do not meet our minimum criteria for funding.</p>
                                <p>We are sorry for any disappointment and wish you well in securing funds from other sources.</p>`,
              ],
            },
          ],
          pass_content: [
            `<p class="font-bold">You meet the Foundation's minimum funding criteria and could be eligible to apply.</p>
                        <p>Please read the application information for our [category name] category for more specific details about the criteria and the trustees' funding priorities.</p>
                        <p>If you are unsure about any of the guidance, please <a href="/contact" class="font-bold">contact us</a>.</p>`,
          ],
        },
        B: {
          name: "Heritage & Conservation",
          sub_questions: [
            {
              text: "Is your charity's annual income between £350,000 and £4million?",
              type: "yesno",
              correct_answer: "Yes",
              fail_explanation: [
                `<p>We're sorry you're not eligible for a grant.</p>
                                <p>Thank you for your interest in applying to the Charles Hayward Foundation but you do not meet our minimum criteria for funding.</p>
                                <p>We are sorry for any disappointment and wish you well in securing funds from other sources.</p>`,
              ],
            },
          ],
          pass_content: [
            `<p class="font-bold">You meet the Foundation's minimum funding criteria and could be eligible to apply.</p>
                        <p>Please read the application information for our [category name] category for more specific details about the criteria and the trustees' funding priorities.</p>
                        <p>If you are unsure about any of the guidance, please <a href="/contact" class="font-bold">contact us</a>.</p>`,
          ],
        },
        C: {
          name: "Overseas",
          sub_questions: [
            {
              text: "Is your charity's annual income between £150,000 and £4million?",
              type: "yesno",
              correct_answer: "Yes",
              fail_explanation: [
                `<p>We're sorry you're not eligible for a grant.</p>
                                <p>Thank you for your interest in applying to the Charles Hayward Foundation but you do not meet our minimum criteria for funding.</p>
                                <p>We are sorry for any disappointment and wish you well in securing funds from other sources.</p>`,
              ],
            },
            {
              text: "Will the project you're seeking funding for be delivered in a Commonwealth country in Africa?",
              type: "yesno",
              correct_answer: "Yes",
              fail_explanation: [
                `<p>We're sorry you're not eligible for a grant.</p>
                                <p>Thank you for your interest in applying to the Charles Hayward Foundation but you do not meet our minimum criteria for funding.</p>
                                <p>We are sorry for any disappointment and wish you well in securing funds from other sources.</p>`,
              ],
            },
          ],
          pass_content: [
            `<p class="font-bold">You meet the Foundation's minimum funding criteria and could be eligible to apply.</p>
                        <p>Please read the application information for our [category name] category for more specific details about the criteria and the trustees' funding priorities.</p>
                        <p>If you are unsure about any of the guidance, please <a href="/contact" class="font-bold">contact us</a>.</p>`,
          ],
        },
        D: {
          name: "Older People",
          sub_questions: [
            {
              text: "Is your charity's annual income less than £350,000?",
              type: "yesno",
              correct_answer: "Yes",
              fail_explanation: [
                `<p>We're sorry you're not eligible for a grant.</p>
                                <p>Thank you for your interest in applying to the Charles Hayward Foundation but you do not meet our minimum criteria for funding.</p>
                                <p>We are sorry for any disappointment and wish you well in securing funds from other sources.</p>`,
              ],
            },
          ],
          pass_content: [
            `<p class="font-bold">You meet the Foundation's minimum funding criteria and could be eligible to apply.</p>
                        <p>Please read the application information for our [category name] category for more specific details about the criteria and the trustees' funding priorities.</p>
                        <p>If you are unsure about any of the guidance, please <a href="/contact" class="font-bold">contact us</a>.</p>`,
          ],
        },
      },
    },
  ],
};

// Quiz Script Variables
let questions;
let result;
let backButton;
let currentQuestionIndex = 0;
let answers = {};

// Function to create an answer button
const createAnswerButton = (value, questionId) => {
  const button = document.createElement("button");
  button.type = "button";
  button.classList.add("btn-answer", "btn", "with-icon");
  button.classList.add(value === "Yes" ? "btn-primary" : "btn-light");
  button.dataset.name = questionId;
  button.dataset.value = value;
  button.textContent = value;

  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.classList.add("icon");
  const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
  use.setAttributeNS(
    "http://www.w3.org/1999/xlink",
    "xlink:href",
    value === "Yes" ? "#secondary-arrow" : "#primary-arrow"
  );
  svg.appendChild(use);
  button.appendChild(svg);

  if (value === "Yes") {
    button.addEventListener("mouseenter", () => {
      use.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        "#primary-arrow"
      );
    });

    button.addEventListener("mouseleave", () => {
      use.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        "#secondary-arrow"
      );
    });
  }

  button.addEventListener("click", handleAnswerClick);
  return button;
};

const updateQuestionVisibility = () => {
  questions.forEach((q, index) => {
    q.classList.toggle("active", index === currentQuestionIndex);
  });

  if (backButton) {
    backButton.style.display =
      currentQuestionIndex === 0 ? "none" : "inline-flex";
    backButton.disabled = currentQuestionIndex === 0;
  }
};

// Function to generate questions
const generateQuestions = () => {
  const quizContainer = document.querySelector(".question-container");
  quizData.questions.forEach((question, index) => {
    const questionElement = document.createElement("div");
    questionElement.classList.add("question", "stack");
    questionElement.dataset.questionId = index;

    const questionCounter = document.createElement("p");
    questionCounter.classList.add("question-counter");
    questionCounter.textContent = `Question ${index + 1}`;

    const questionText = document.createElement("p");
    questionText.classList.add("question-text");
    questionText.textContent = question.text;

    questionElement.appendChild(questionCounter);
    questionElement.appendChild(questionText);

    const optionsContainer = document.createElement("div");
    optionsContainer.classList.add(
      "options-container",
      "cluster",
      "cluster--no-wrap",
      "cluster--small"
    );

    if (question.type === "yesno") {
      ["Yes", "No"].forEach((value) => {
        const button = createAnswerButton(value, `q${question.id}`);
        optionsContainer.appendChild(button);
      });
    } else if (question.type === "category") {
      const selectWrapper = document.createElement("div");
      selectWrapper.classList.add("select-wrapper", "with-icon");

      const select = document.createElement("select");
      select.classList.add("select-answer");
      select.dataset.name = `q${question.id}`;

      const defaultOption = document.createElement("option");
      defaultOption.value = "";
      defaultOption.textContent = "Please select...";
      select.appendChild(defaultOption);

      Object.entries(question.options).forEach(([key, option]) => {
        const optionElement = document.createElement("option");
        optionElement.value = key;
        optionElement.textContent = option.name;
        select.appendChild(optionElement);
      });

      // Append the <span> element with an SVG icon
      const svgWrapper = document.createElement("span");
      svgWrapper.classList.add("select-icon");

      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("viewBox", "0 0 48 48");
      svg.setAttribute("width", "48");
      svg.setAttribute("height", "48");
      svg.classList.add("icon");

      const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
      use.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        "#secondary-arrow-down"
      );
      svg.appendChild(use);

      svgWrapper.appendChild(svg);

      // Add click event to the icon to trigger the select dropdown
      svgWrapper.addEventListener("click", () => {
        // Focus the select element first
        select.focus();

        // Try the modern showPicker() method if available
        if (typeof select.showPicker === "function") {
          try {
            select.showPicker();
            return;
          } catch (e) {
            // Fall back to other methods if showPicker fails
          }
        }

        // Fall back to click simulation
        const clickEvent = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        });
        select.dispatchEvent(clickEvent);
      });

      // Wrap the <select> and <span> inside a container for proper layout
      selectWrapper.appendChild(select);
      selectWrapper.appendChild(svgWrapper);

      // Add event listener for the select element
      select.addEventListener("change", handleAnswerSelect);

      // Append the selectWrapper to optionsContainer
      optionsContainer.appendChild(selectWrapper);
    }

    questionElement.appendChild(optionsContainer);
    quizContainer.appendChild(questionElement);
  });

  questions = document.querySelectorAll(".question");
  result = document.querySelector(".result");
  backButton = document.querySelector(".back-button");

  updateQuestionVisibility(); // Show the first question
};

// Function to handle the quiz logic
const handleQuiz = () => {
  let isEligible = true;
  let resultMessage = "";

  for (const [questionId, answer] of Object.entries(answers)) {
    const question = quizData.questions[questionId];
    if (question.type === "yesno" && answer !== question.correct_answer) {
      isEligible = false;
      resultMessage = question.fail_explanation;
      break;
    } else if (question.type === "category") {
      const selectedCategory = question.options[answer];
      selectedCategory.sub_questions.forEach((subQ) => {
        if (answers[`sub-${subQ.id}`] !== subQ.correct_answer) {
          isEligible = false;
          resultMessage = subQ.fail_explanation;
        }
      });

      if (isEligible) {
        resultMessage = selectedCategory.pass_content;
      }
    }
  }

  questions.forEach((q) => q.classList.remove("active"));

  // Update result message
  result.innerHTML = isEligible
    ? `<p>Congratulations!</p><p>${resultMessage}</p>`
    : `<p>Ineligible</p><p>${renderFailExplanation(resultMessage)}</p>`;
  result.style.display = "block";
  backButton.style.display = "none";
};

// Function to render the fail explanation (handles both string and array cases)
const renderFailExplanation = (failExplanation) => {
  if (Array.isArray(failExplanation)) {
    return failExplanation.map((paragraph) => paragraph).join(""); // Join paragraphs without commas
  }
  return failExplanation; // For single string case, just return it
};

// Function to handle answer selection
const handleAnswerSelection = (questionId, answer) => {
  answers[questionId] = answer;

  // If handling a sub-question, don't proceed with regular progression
  if (questionId.startsWith("sub-")) {
    return;
  }

  if (currentQuestionIndex < questions.length - 1) {
    questions[currentQuestionIndex].classList.remove("active");
    currentQuestionIndex++;
    questions[currentQuestionIndex].classList.add("active");
    updateQuestionVisibility();
  } else {
    handleQuiz(); // End quiz if at the last question
  }
};

// Function to reset quiz state
const resetQuiz = () => {
  // Reset current question index
  currentQuestionIndex = 0;

  // Clear previous answers
  answers = {};

  // Remove any sub-questions that might have been added
  const subQuestions = document.querySelectorAll('[class*="sub-question-"]');
  subQuestions.forEach((sq) => sq.remove());

  // Reset any selected values in dropdowns
  const selects = document.querySelectorAll("select.select-answer");
  selects.forEach((select) => (select.value = ""));

  // Show first question and update visibility
  const questions = document.querySelectorAll(".question");
  questions.forEach((q, index) => {
    q.classList.toggle("active", index === 0);
  });

  // Show the main back button but disable it since we're on first question
  const mainBackButton = document.querySelector(".back-button");
  if (mainBackButton) {
    mainBackButton.style.display = "inline-flex";
    mainBackButton.disabled = true;
  }
};

// Function to show result message
const showResultMessage = (isSuccess, title, message) => {
  questions.forEach((q) => q.classList.remove("active"));

  const mainBackButton = document.querySelector(".back-button");
  if (mainBackButton) {
    mainBackButton.style.display = "none";
  }

  const resultDiv = document.createElement("div");
  resultDiv.classList.add("result", "stack");
  resultDiv.classList.add(isSuccess ? "success" : "failure");

  const resultTitle = document.createElement("p");
  resultTitle.innerHTML = title;
  resultDiv.appendChild(resultTitle);

  const resultMessage = document.createElement("p");
  resultMessage.classList.add("result-message", "stack");
  resultMessage.innerHTML = message;
  resultDiv.appendChild(resultMessage);

  const quizContainer = document.querySelector(".question-container");
  const existingResult = quizContainer.querySelector(".result");
  if (existingResult) {
    existingResult.remove();
  }

  quizContainer.appendChild(resultDiv);
};

const handleAnswerClick = (e) => {
  // Find the button element that was clicked or contains the clicked element
  const button = e.target.closest(".btn-answer") || e.target;

  // Make sure we have a button element with the necessary data attributes
  if (!button.dataset || !button.dataset.name || !button.dataset.value) {
    return;
  }

  const questionId = button.dataset.name;
  const answer = button.dataset.value;

  // Sub-question logic
  if (questionId.startsWith("sub-")) {
    const categoryKey = questionId.replace("sub-", "");
    const category = quizData.questions[2].options[categoryKey];
    const currentSubQuestionIndex = answers[`sub-${categoryKey}-index`] || 0;

    if (answer === "No") {
      // Fail if any sub-question is answered "No"
      const failureMessage =
        category.sub_questions[currentSubQuestionIndex].fail_explanation;
      showResultMessage(false, "Quiz completed", failureMessage);
      return;
    }

    if (
      answer === "Yes" &&
      currentSubQuestionIndex < category.sub_questions.length - 1
    ) {
      // Show the next sub-question
      const nextSubQuestionIndex = currentSubQuestionIndex + 1;
      answers[`sub-${categoryKey}-index`] = nextSubQuestionIndex;

      const nextSubQuestion = category.sub_questions[nextSubQuestionIndex];
      const subQuestionDiv = document.createElement("div");
      subQuestionDiv.classList.add(
        "question",
        `sub-question-${categoryKey}`,
        `sub-question-${categoryKey}-${nextSubQuestionIndex}`,
        "stack"
      );

      // Add the question counter
      const questionCounter = document.createElement("p");
      questionCounter.classList.add("question-counter");
      questionCounter.textContent = `Question ${4 + nextSubQuestionIndex}`;
      subQuestionDiv.appendChild(questionCounter);

      // Add the selected category text (ABOVE the question text)
      const selectedOptionText = document.createElement("p");
      selectedOptionText.classList.add("selected-option-text");
      selectedOptionText.textContent = `You selected: ${category.name}`;
      subQuestionDiv.appendChild(selectedOptionText);

      // Add the sub-question text
      const questionText = document.createElement("p");
      questionText.classList.add("question-text");
      questionText.textContent = nextSubQuestion.text;
      subQuestionDiv.appendChild(questionText);

      // Add answer buttons
      const yesButton = createAnswerButton("Yes", `sub-${categoryKey}`);
      const noButton = createAnswerButton("No", `sub-${categoryKey}`);
      const optionsContainer = document.createElement("div");
      optionsContainer.classList.add(
        "options-container",
        "cluster",
        "cluster--no-wrap",
        "cluster--small"
      );
      optionsContainer.appendChild(yesButton);
      optionsContainer.appendChild(noButton);
      subQuestionDiv.appendChild(optionsContainer);

      // Insert the next sub-question after the current one
      const currentQuestion = questions[currentQuestionIndex];
      currentQuestion.insertAdjacentElement("afterend", subQuestionDiv);

      // Update questions and visibility
      questions = document.querySelectorAll(".question");
      currentQuestionIndex++;
      updateQuestionVisibility();
      return;
    }

    if (
      answer === "Yes" &&
      currentSubQuestionIndex === category.sub_questions.length - 1
    ) {
      // If all sub-questions are answered "Yes", show success message
      // First get the success message content from the category
      let successMessage = category.pass_content.join("");

      // Replace the category name placeholder with a clickable link
      successMessage = successMessage.replace(
        /\[category name\]/g,
        `<a href="/grants/${category.name
          .toLowerCase()
          .replace(/\s+/g, "-")}" class="font-bold">${category.name}</a>`
      );
      showResultMessage(true, "Quiz completed", successMessage);
      return;
    }
  }

  // Handle main question logic
  if (answer === "No") {
    const questionIndex = parseInt(questionId.replace("q", "")) - 1;
    const failureMessage = quizData.questions[questionIndex].fail_explanation;
    showResultMessage(false, "Quiz completed", failureMessage);
    return;
  }

  // Progress main questions
  const mainQuestionId = questionId.replace("q", "");
  handleAnswerSelection(mainQuestionId, answer);
};

const handleAnswerSelect = (e) => {
  const questionId = e.target.dataset.name.replace("q", "");
  const selectedValue = e.target.value;

  if (selectedValue) {
    // Save the selected answer
    answers[questionId] = selectedValue;

    // Special handling for Heritage & Conservation (option B)
    if (selectedValue === "B") {
      // Show closed message immediately
      showResultMessage(
        false,
        "<strong>Category Closed</strong>",
        `<p>Our <a href="/grants/heritage-conservation" class="font-bold">Heritage & Conservation</a> category is currently closed to new applications.</p>
           <p>There are no plans to re-open this category in the immediate future.</p>
           <p>Please refer to the website for any updates.</p>`
      );
      return;
    }

    const selectedCategory = quizData.questions[2].options[selectedValue];

    // Remove any existing sub-questions for this category
    const existingSubQuestions = document.querySelectorAll(
      `.sub-question-${selectedValue}`
    );
    existingSubQuestions.forEach((sq) => sq.remove());

    // Add the first sub-question if it exists
    if (selectedCategory.sub_questions) {
      const firstSubQuestion = selectedCategory.sub_questions[0];
      answers[`sub-${selectedValue}-index`] = 0; // Track current sub-question index

      const subQuestionDiv = document.createElement("div");
      subQuestionDiv.classList.add(
        "question",
        `sub-question-${selectedValue}`,
        `sub-question-${selectedValue}-0`,
        "stack"
      );

      // Add the question counter
      const questionCounter = document.createElement("p");
      questionCounter.classList.add("question-counter");
      questionCounter.textContent = `Question 4`;
      subQuestionDiv.appendChild(questionCounter);

      // Add the selected category text
      const selectedOptionText = document.createElement("p");
      selectedOptionText.classList.add("selected-option-text");
      selectedOptionText.textContent = `You selected: ${selectedCategory.name}`;
      subQuestionDiv.appendChild(selectedOptionText);

      // Add the sub-question text
      const questionText = document.createElement("p");
      questionText.classList.add("question-text");
      questionText.textContent = firstSubQuestion.text;
      subQuestionDiv.appendChild(questionText);

      // Add answer buttons
      const yesButton = createAnswerButton("Yes", `sub-${selectedValue}`);
      const noButton = createAnswerButton("No", `sub-${selectedValue}`);
      const optionsContainer = document.createElement("div");
      optionsContainer.classList.add(
        "options-container",
        "cluster",
        "cluster--no-wrap",
        "cluster--small"
      );
      optionsContainer.appendChild(yesButton);
      optionsContainer.appendChild(noButton);
      subQuestionDiv.appendChild(optionsContainer);

      // Insert the sub-question after the current question
      const currentQuestion = questions[currentQuestionIndex];
      currentQuestion.insertAdjacentElement("afterend", subQuestionDiv);

      // Update questions and visibility
      questions = document.querySelectorAll(".question");
      currentQuestionIndex++;
      updateQuestionVisibility();
      return;
    }

    // If no sub-questions, move to the next main question
    handleAnswerSelection(questionId, selectedValue);
  }
};

// Function to handle back button click
const handleBackButtonClick = () => {
  if (currentQuestionIndex > 0) {
    questions[currentQuestionIndex].classList.remove("active");
    currentQuestionIndex--;
    questions[currentQuestionIndex].classList.add("active");
    updateQuestionVisibility();
  }
};

// Updated back button creation
document.addEventListener("DOMContentLoaded", () => {
  generateQuestions();

  // Configure the back button
  backButton = document.querySelector(".back-button");
  if (backButton) {
    backButton.classList.add("btn", "btn-back", "with-icon"); // Add styling classes
    backButton.textContent = "Back";

    // Create SVG element
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.classList.add("icon"); // Add the icon class
    const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
    use.setAttributeNS(
      "http://www.w3.org/1999/xlink",
      "xlink:href",
      "#primary-arrow-back"
    );
    svg.appendChild(use);

    // Append the SVG icon to the back button
    backButton.appendChild(svg);

    // Add the click event listener
    backButton.addEventListener("click", handleBackButtonClick);
  }

  updateQuestionVisibility();
});

// Event listeners
document.addEventListener("DOMContentLoaded", () => {
  generateQuestions();

  document.querySelectorAll(".answer-button").forEach((button) => {
    button.addEventListener("click", (e) => {
      const questionId = e.target.dataset.questionId;
      const answer = e.target.dataset.answer;
      handleAnswerSelection(questionId, answer);
    });
  });

  backButton = document.querySelector(".back-button");
  backButton.addEventListener("click", handleBackButtonClick);
  updateQuestionVisibility();

  // Add hover event listeners for primary buttons
  document.querySelectorAll(".btn-primary").forEach((button) => {
    const arrowIcon = button.querySelector("use");

    button.addEventListener("mouseenter", () => {
      arrowIcon.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        "#primary-arrow"
      );
    });

    button.addEventListener("mouseleave", () => {
      arrowIcon.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        "#secondary-arrow"
      );
    });
  });
});
